import { FC, PropsWithChildren } from 'react';
import { ConfigProvider } from 'antd';

export const HeaderSearchInputProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Input: {
              // controlHeight: 55,
              // fontSize: 18,
              fontFamily: 'Inter',
              borderRadius: 16,
            },
          },
        }}
      >
        {children}
      </ConfigProvider>
    </>
  );
};
